import { useFeatureFlags } from 'hooks/useFeatureFlags'
import { useXeroIntegration } from 'lib/hooks/useXeroIntegration'

export const useShouldShowXeroMappings = (): boolean => {
  const flags = useFeatureFlags()
  const { xeroIntegration } = useXeroIntegration()

  return Boolean(flags.useXeroLedgerAccountMappings && xeroIntegration?.enabled)
}
